import { http } from "@next-core/http";

/** 协作空间模式信息 */

/**
 * @description 获取协作空间的模式定义（业务对象、关系、业务流）
 * @endpoint GET /api/v1/elevo/spaces/:spaceId/schema
 */
export const ElevoSpaceApi_getSpaceSchema = async (spaceId, options) => /**! @contract easyops.api.llm.elevo_space.GetSpaceSchema@1.0.0 */(await http.get(`api/gateway/logic.llm.aiops_service/api/v1/elevo/spaces/${spaceId}/schema`, options)).data;
//# sourceMappingURL=getSpaceSchema.js.map